import { COLORS } from 'Components/utils/color/colors.js';

export const themes = {
  default: {
    thRoot: 'relative',
    thIconContainer:
      'absolute flex items-center gradient-linear-transparent-black-80 p-2 bottom-0 text-white w-full',
    thText: 'truncate rtl:ml-1',
    thIcon: 'flex-shrink-0',
    thIconWidth: 'calc(20rem / 16)',
    thIconColor: COLORS.WHITE,
    thImageSize: { w: 1000 },
    changeWidthButHeightIsAuto: true,
  },
  cards: {
    thRoot: 'relative rounded-tiny overflow-hidden',
    thIconContainer: 'absolute flex items-center justify-end p-3 sm:p-5 top-0 text-white w-full',
    thText: 'truncate rtl:ml-1 text-sm font-bold',
    thIcon: 'flex-no-shrink',
    thIconWidth: '1rem',
    thIconColor: COLORS.WHITE,
    thImageSize: { w: 500, h: 500 },
    changeWidthButHeightIsAuto: false,
  },
};
